import {createActionWithPayload} from "../../utils.actions";
import {AdminPublicationPlanCollection} from "../../../epics/admin/publication/admin-publication.epics";

export const [saveAdminPublicationPlan, isSaveAdminPublicationPlan] = createActionWithPayload<AdminPublicationPlanCollection>('ADMIN_SAVE_PUBLICATION_PLAN')
export const [setDirty, isSetDirty] = createActionWithPayload<boolean>('ADMIN_SET_PUBLICATION_DIRTY')
